module.exports = __webpack_public_path__ + "img/pitchup-logo.2.0352ff3.png";